import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  text: {
    fill: '#ffffff',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 700,
    fontSize: '18px',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 28">
      <text className={classes.text} x="50%" y="50%" dominantBaseline="central" textAnchor="middle">
        AGM
      </text>
    </svg>
  );
};
